<template>
  <v-autocomplete
    v-model="localeValue"
    :items="processes"
    :label="$t(schema.name)"
    dense
    filled
  />
</template>

<script>

export default {
  name: 'dr-process-autocomplete',
  props: ['schema', 'value'],
  data() {
    return {
      processes: []
    }
  },
  computed: {
    localeValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  async created() {
    const data = await this.$store.dispatch('processes/getBusinessProcesses')
    this.processes = data.map(x => ({
      value: x.id,
      text: x.name
    }))
  }
}
</script>